import { render, staticRenderFns } from "./IndustryCategorySelect.vue?vue&type=template&id=4c27894c"
import script from "./IndustryCategorySelect.vue?vue&type=script&lang=js"
export * from "./IndustryCategorySelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports